import { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Lock, Mail } from "lucide-react";
import SEO from "@/components/SEO";

export default function AdminLogin() {
    const { login, user, loading } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("admin@secondprep.com");
    const [password, setPassword] = useState("Admin@123");
    const [busy, setBusy] = useState(false);

    if (!loading && user?.role === "admin") {
        return <Navigate to="/admin" replace />;
    }

    if (!loading && user?.role === "customer") {
        return <Navigate to="/profile" replace />;
    }

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const data = await login(email, password);
            if (data?.role !== "admin") {
                toast.error("এই অ্যাকাউন্টে admin অ্যাক্সেস নেই");
            } else {
                toast.success("লগইন সফল");
            }
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <>
            <SEO title="Admin Login" />
            <div className="min-h-screen bg-hero-grad grid place-items-center px-4 relative overflow-hidden">
            <span className="math-symbol text-[120px] sm:text-[200px] left-[5%] top-[5%]">∑</span>
            <span className="math-symbol text-[100px] sm:text-[180px] right-[5%] bottom-[10%]">π</span>
            <div className="glass rounded-2xl sm:rounded-3xl p-6 sm:p-8 w-full max-w-md relative shadow-pop mx-4 sm:mx-0">
                <div className="text-center">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 mx-auto rounded-xl sm:rounded-2xl btn-primary grid place-items-center font-bold shadow-pop">SP</div>
                    <h1 className="text-xl sm:text-2xl font-bold text-brand-navy mt-3 sm:mt-4">Admin Panel</h1>
                    <p className="text-xs sm:text-sm text-brand-navy/60 mt-1">Self Preparation • Dashboard Login</p>
                </div>
                <form onSubmit={submit} className="mt-6 sm:mt-8 space-y-4">
                    <div>
                        <label className="block text-xs font-medium mb-1.5 text-brand-navy">Email</label>
                        <div className="relative">
                            <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-brand-royal/50" />
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full pl-10 pr-3 py-2.5 rounded-lg border border-brand-light bg-white focus:outline-none focus:ring-2 focus:ring-brand-royal/30"
                                data-testid="admin-email-input"
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block text-xs font-medium mb-1.5 text-brand-navy">Password</label>
                        <div className="relative">
                            <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-brand-royal/50" />
                            <input
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full pl-10 pr-3 py-2.5 rounded-lg border border-brand-light bg-white focus:outline-none focus:ring-2 focus:ring-brand-royal/30"
                                data-testid="admin-password-input"
                            />
                        </div>
                    </div>
                    <button
                        disabled={busy}
                        className="btn-primary w-full py-3 rounded-lg font-semibold disabled:opacity-60"
                        data-testid="admin-login-submit"
                    >
                        {busy ? "Logging in..." : "Login"}
                    </button>
                </form>
            </div>
        </div>
        </>
    );
}